// extracted by mini-css-extract-plugin
export default {"root":"ZoomPan_root__uJqr4","point":"ZoomPan_point__Fn-lL","canvas":"ZoomPan_canvas__fPkEz"};